import type {HighlightColor} from './annotationTypes';

/**
 * The same fills the marks are painted with (annotations-highlights.scss), for the
 * chrome that has to restate a mark: swatches, quoted text.
 */
export const HIGHLIGHT_BACKGROUND_CLASS: Record<HighlightColor, string> = {
  yellow: 'bg-(--color-background-highlight-yellow)',
  blue: 'bg-(--color-background-highlight-blue)',
  pink: 'bg-(--color-background-highlight-pink)'
};

/**
 * Holds a mark's yellow across an atomic button's states, which otherwise revert to
 * the grey `secondary` fill on hover at a specificity no utility can outrank.
 */
export const HIGHLIGHT_BUTTON_CLASS = [
  '[--button-background-color:var(--color-background-highlight-yellow)]',
  '[--button-background-color--hover:var(--color-background-highlight-subtle-pressed)]',
  '[--button-background-color--active:var(--color-background-highlight-subtle-pressed)]'
].join(' ');
